import {Navbar, Nav, Button, NavDropdown} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {useAuth} from "./auth/AuthProvider"
import { FaUserCircle } from "react-icons/fa";
import {version} from "../version";
import {ROUTES} from "../routes";

export default function AppNavbar() {
    const {doLogout} = useAuth();
    const navigate = useNavigate();
    // const token = getValidToken();

    const logout = () => {
        doLogout();
        navigate("/login");
    }

    return (
        <Navbar className={"bg-dark-subtle"}>
            <Nav className={"p-1"}>
                <Nav.Link href={ROUTES.HOME}>Home</Nav.Link>
            </Nav>
            <Nav className={"p-1"}>
                <Nav.Link href={ROUTES.PROVISION}>Provision</Nav.Link>
            </Nav>

            <Nav className={"p-1"}>
                <Nav.Link href={ROUTES.MACHINES}>Machines</Nav.Link>
            </Nav>

            <Nav className={"ms-auto p-1"}>
                <Nav.Link className="me-3">
                    <span style={{ fontSize: "0.9rem", color: "#666" }}>V: {version}</span>
                </Nav.Link>


                <NavDropdown title={
                        <FaUserCircle size={24} />
                }   // 👈 use the icon here
                             id="user-nav-dropdown"
                             align="end"
                             >
                    <NavDropdown.Item href={ROUTES.PROFILE}>Profile</NavDropdown.Item>
                    {/*<NavDropdown.Item href="#settings">Settings</NavDropdown.Item>*/}
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="#" onClick={logout}>Logout</NavDropdown.Item>

                </NavDropdown>
            </Nav>

            

        </Navbar>

    )
}
